import request from '@/utils/request'

// 查询商品管理分页
export function fetchList(query) {
    return request({
        url: '/taxation/prod/page',
        method: 'get',
        params: query,
    })
}
// 查询商品管理不分页
export function prodList(query) {
    return request({
        url: '/taxation/prod/page',
        method: 'get',
        params: query,
    })
}
export function fetchList2(query) {
    return request({
        url: '/taxation/category/page',
        method: 'get',
        params: query,
    })
}
// 查询商品详细
export function getObj(id) {
    return request({
        url: '/taxation/prod/detail?prodId=' + id,
        method: 'get',
    })
}
// 新增商品
export function addObj(data) {
    return request({
        url: '/taxation/prod/add',
        method: 'post',
        data: data,
    })
}

// 修改商品
export function putObj(data) {
    return request({
        url: '/taxation/prod/edit',
        method: 'post',
        data: data,
    })
}
// 删除商品
export function delObj(data) {
    return request({
        url: '/taxation/prod/delete',
        method: 'post',
        data: data,
    })
}
// 下架商品
export function prodDow(data) {
    return request({
        url: '/taxation/prod/dow',
        method: 'post',
        data: data,
    })
}
// 上架商品
export function prodUp(data) {
    return request({
        url: '/taxation/prod/up',
        method: 'post',
        data: data,
    })
}
// 增加库存
export function prodInventory(data) {
    return request({
        url: '/integral/prod/inventory',
        method: 'post',
        data: data,
    })
}
